export default class Log {
    /**
     * The type of the log, use info, warn or error.
     */
    public type = '';

    /**
     * E.g notFound or any string which marks what happened.
     */
    public event = '';

    /**
     * Long description of the event, its a string. It can be the exception stack
     * or anything else.
     */
    public description = '';

    /**
     * The part of the code where the log was created. E.g UserService.create
     */
    public performer = '';

    /**
     * Time when the event you would like to log happened.
     */
    public createdAt: Date = new Date(0);

    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.type) {
            this.type = model.type;
        }
        if (model.event) {
            this.event = model.event;
        }
        if (model.description) {
            this.description = model.description;
        }
        if (model.performer) {
            this.performer = model.performer;
        }
        if (model.createdAt) {
            this.createdAt = model.createdAt;
        } else {
            this.createdAt = new Date();
        }
    }
}
